import React from "react";
import { FolderOpen } from "lucide-react";

const ArchivumWorkspace = ({
    folders,
    activeFolderId,
    setActiveFolderId,

    newFolderName,
    setNewFolderName,

    newFolderDescription,
    setNewFolderDescription,

    isResourceFolderCreatorOpen,
    setIsResourceFolderCreatorOpen,

    editingFolderId,
    editingFolderName,
    setEditingFolderName,

    editingFolderDescription,
    setEditingFolderDescription,

    createFolder,
    startEditingFolder,
    cancelEditingFolder,
    saveEditedFolder,
    deleteFolder,

    setNotes,
    setActiveWorkspace,
}) => {
    return (
        <div className="flex h-full min-h-0 flex-col">
            <div className="mb-3 flex items-center justify-between gap-3">
                <div>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-[#d8b4fe]">
                        Classroom Library
                    </p>

                    <h3 className="mt-1 font-display text-xl text-[#ffd166]">
                        Archivum
                    </h3>
                </div>
            </div>

            <div className="mb-4">
                <button
                    type="button"
                    onClick={() =>
                        setIsResourceFolderCreatorOpen(
                            (currentValue) =>
                                !currentValue
                        )
                    }
                    className="
                        inline-flex
                        items-center
                        gap-2
                        rounded-xl
                        border
                        border-[#c084fc]/45
                        bg-[#2b1548]/70
                        px-3
                        py-2
                        text-xs
                        font-semibold
                        text-[#f3e8ff]
                        transition
                        hover:border-[#ffd166]
                        hover:text-[#ffd166]
                    "
                >
                    Add Folder

                    <span className="text-[10px]">
                        {isResourceFolderCreatorOpen
                            ? "▲"
                            : "▼"}
                    </span>
                </button>

                {isResourceFolderCreatorOpen && (
                    <div className="mt-3 rounded-2xl border border-[#ffd166]/20 bg-black/40 p-3">
                        <p className="text-[10px] uppercase tracking-[0.18em] text-[#d8b4fe]">
                            New Archivum Folder
                        </p>

                        <div className="mt-3 space-y-2">
                            <input
                                type="text"
                                value={newFolderName}
                                onChange={(event) =>
                                    setNewFolderName(
                                        event.target.value
                                    )
                                }
                                placeholder="Folder name"
                                className="
                                    w-full
                                    rounded-xl
                                    border
                                    border-[#ffd166]/30
                                    bg-[#080b14]
                                    px-3
                                    py-2
                                    text-sm
                                    text-[#fff3c4]
                                    outline-none
                                    placeholder:text-[#6c7a9c]
                                    focus:border-[#ffd166]
                                "
                            />

                            <textarea
                                value={
                                    newFolderDescription
                                }
                                onChange={(event) =>
                                    setNewFolderDescription(
                                        event.target.value
                                    )
                                }
                                placeholder="Optional description"
                                className="
                                    min-h-[72px]
                                    w-full
                                    resize-y
                                    rounded-xl
                                    border
                                    border-[#ffd166]/30
                                    bg-[#080b14]
                                    px-3
                                    py-2
                                    text-sm
                                    text-[#fff3c4]
                                    outline-none
                                    placeholder:text-[#6c7a9c]
                                    focus:border-[#ffd166]
                                "
                            />

                            <div className="flex flex-wrap gap-2">
                                <button
                                    type="button"
                                    onClick={() => {
                                        createFolder();

                                        if (
                                            newFolderName.trim()
                                        ) {
                                            setIsResourceFolderCreatorOpen(
                                                false
                                            );
                                        }
                                    }}
                                    disabled={
                                        !newFolderName.trim()
                                    }
                                    className="
                                        rounded-xl
                                        border
                                        border-[#ffd166]/45
                                        bg-[#2b1548]/80
                                        px-3
                                        py-2
                                        text-xs
                                        font-semibold
                                        text-[#ffd166]
                                        transition
                                        hover:border-[#ffd166]
                                        hover:bg-[#ffd166]/10
                                        disabled:cursor-not-allowed
                                        disabled:opacity-40
                                    "
                                >
                                    Create Folder
                                </button>

                                <button
                                    type="button"
                                    onClick={() => {
                                        setNewFolderName("");
                                        setNewFolderDescription(
                                            ""
                                        );
                                        setIsResourceFolderCreatorOpen(
                                            false
                                        );
                                    }}
                                    className="
                                        rounded-xl
                                        border
                                        border-[#c084fc]/35
                                        bg-black
                                        px-3
                                        py-2
                                        text-xs
                                        text-[#d8b4fe]
                                        transition
                                        hover:border-[#c084fc]/70
                                    "
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto pr-1">
                {folders.length === 0 ? (
                    <div className="rounded-2xl border border-[#ffd166]/20 bg-[#080b14] p-4">
                        <p className="text-sm text-[#fff3c4]">
                            No Archivum folders yet.
                        </p>

                        <p className="mt-1 text-xs text-[#b0b8d6]">
                            Create folders to organize notes,
                            Tabula boards, readings, slides,
                            worksheets, PDFs, videos, links,
                            and other classroom resources.
                        </p>
                    </div>
                ) : (
                    <div className="space-y-2">
                        {folders.map((folder) => {
                            const folderResources =
                                Array.isArray(
                                    folder.resources
                                )
                                    ? folder.resources
                                    : [];

                            return (
                                <div
                                    key={folder.id}
                                    className="
                                        overflow-hidden
                                        rounded-2xl
                                        border
                                        border-[#ffd166]/20
                                        bg-[#080b14]
                                    "
                                >
                                    <div
                                        className={`
                                            w-full
                                            px-4
                                            py-3
                                            transition-all
                                            ${
                                                activeFolderId ===
                                                folder.id
                                                    ? "bg-[#ffd166]/10"
                                                    : ""
                                            }
                                        `}
                                    >
                                        <div className="flex items-start gap-3">
                                            <FolderOpen
                                                size={18}
                                                className="mt-0.5 shrink-0 text-[#ffd166]"
                                            />

                                            <div className="min-w-0 flex-1">
                                                {editingFolderId ===
                                                folder.id ? (
                                                    <div className="space-y-2">
                                                        <input
                                                            type="text"
                                                            value={
                                                                editingFolderName
                                                            }
                                                            onChange={(
                                                                event
                                                            ) =>
                                                                setEditingFolderName(
                                                                    event
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                            className="
                                                                w-full
                                                                rounded-xl
                                                                border
                                                                border-[#ffd166]/30
                                                                bg-black
                                                                px-3
                                                                py-2
                                                                text-sm
                                                                text-[#fff3c4]
                                                                outline-none
                                                                focus:border-[#ffd166]
                                                            "
                                                        />

                                                        <textarea
                                                            value={
                                                                editingFolderDescription
                                                            }
                                                            onChange={(
                                                                event
                                                            ) =>
                                                                setEditingFolderDescription(
                                                                    event
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                            className="
                                                                min-h-[64px]
                                                                w-full
                                                                resize-y
                                                                rounded-xl
                                                                border
                                                                border-[#ffd166]/30
                                                                bg-black
                                                                px-3
                                                                py-2
                                                                text-xs
                                                                text-[#fff3c4]
                                                                outline-none
                                                                focus:border-[#ffd166]
                                                            "
                                                        />

                                                        <div className="flex flex-wrap gap-2">
                                                            <button
                                                                type="button"
                                                                onClick={
                                                                    saveEditedFolder
                                                                }
                                                                className="
                                                                    rounded-lg
                                                                    border
                                                                    border-[#ffd166]/45
                                                                    bg-[#2b1548]/70
                                                                    px-2.5
                                                                    py-1.5
                                                                    text-[10px]
                                                                    font-semibold
                                                                    text-[#ffd166]
                                                                "
                                                            >
                                                                Save
                                                            </button>

                                                            <button
                                                                type="button"
                                                                onClick={
                                                                    cancelEditingFolder
                                                                }
                                                                className="
                                                                    rounded-lg
                                                                    border
                                                                    border-[#c084fc]/30
                                                                    bg-black
                                                                    px-2.5
                                                                    py-1.5
                                                                    text-[10px]
                                                                    text-[#d8b4fe]
                                                                "
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-start justify-between gap-3">
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setActiveFolderId(
                                                                    folder.id
                                                                )
                                                            }
                                                            className="
                                                                min-w-0
                                                                flex-1
                                                                text-left
                                                            "
                                                        >
                                                            <p className="text-sm font-semibold text-[#fff3c4]">
                                                                {folder.name ||
                                                                    "Untitled Folder"}
                                                            </p>

                                                            {folder.description && (
                                                                <p className="mt-1 text-xs text-[#b0b8d6]">
                                                                    {
                                                                        folder.description
                                                                    }
                                                                </p>
                                                            )}

                                                            <p className="mt-1 text-[10px] uppercase tracking-[0.16em] text-[#8f98b5]">
                                                                {
                                                                    folderResources.length
                                                                }{" "}
                                                                resource
                                                                {folderResources.length ===
                                                                1
                                                                    ? ""
                                                                    : "s"}
                                                            </p>
                                                        </button>

                                                        <div className="flex shrink-0 gap-1">
                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    startEditingFolder(
                                                                        folder
                                                                    )
                                                                }
                                                                className="
                                                                    rounded-lg
                                                                    border
                                                                    border-[#c084fc]/30
                                                                    bg-black
                                                                    px-2
                                                                    py-1
                                                                    text-[10px]
                                                                    text-[#d8b4fe]
                                                                    hover:border-[#ffd166]
                                                                    hover:text-[#ffd166]
                                                                "
                                                            >
                                                                Rename
                                                            </button>

                                                            <button
                                                                type="button"
                                                                onClick={() =>
                                                                    deleteFolder(
                                                                        folder.id
                                                                    )
                                                                }
                                                                className="
                                                                    rounded-lg
                                                                    border
                                                                    border-red-400/30
                                                                    bg-black
                                                                    px-2
                                                                    py-1
                                                                    text-[10px]
                                                                    text-red-200
                                                                    hover:border-red-300
                                                                "
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {activeFolderId ===
                                        folder.id && (
                                        <div className="border-t border-[#ffd166]/15 p-3">
                                            {folderResources.length ===
                                            0 ? (
                                                <p className="text-xs text-[#7f8baa]">
                                                    Nothing saved in
                                                    this folder yet.
                                                </p>
                                            ) : (
                                                <div className="space-y-2">
                                                    {folderResources.map(
                                                        (
                                                            resource
                                                        ) => (
                                                            <button
                                                                key={
                                                                    resource.id
                                                                }
                                                                type="button"
                                                                onClick={() => {
                                                                    if (
                                                                        resource.openTarget ===
                                                                        "notebook"
                                                                    ) {
                                                                        setActiveFolderId(
                                                                            resource.folderId ||
                                                                                folder.id
                                                                        );

                                                                        if (
                                                                            resource.snapshotHtml !==
                                                                            undefined
                                                                        ) {
                                                                            setNotes(
                                                                                resource.snapshotHtml ||
                                                                                    ""
                                                                            );
                                                                        }

                                                                        setActiveWorkspace(
                                                                            "notepad"
                                                                        );
                                                                    }
                                                                }}
                                                                className="
                                                                    w-full
                                                                    rounded-xl
                                                                    border
                                                                    border-[#c084fc]/25
                                                                    bg-black/50
                                                                    px-3
                                                                    py-3
                                                                    text-left
                                                                    transition
                                                                    hover:border-[#ffd166]/55
                                                                    hover:bg-[#2b1548]/30
                                                                "
                                                            >
                                                                <p className="text-sm font-semibold text-[#fff3c4]">
                                                                    {resource.title ||
                                                                        "Untitled Resource"}
                                                                </p>

                                                                <p className="mt-1 text-[10px] uppercase tracking-[0.16em] text-[#d8b4fe]">
                                                                    {resource.type ===
                                                                    "notebook"
                                                                        ? "Notebook"
                                                                        : resource.type ||
                                                                          "Resource"}
                                                                </p>
                                                            </button>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ArchivumWorkspace;